export default __webpack_public_path__ + "static/media/bananaTtsIt_It60.45837c17.mp3";